import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { UserGroupMembersField } from './UserGroupMembersField';

export const UserGroupMembersFieldExtension = FormFieldBlueprint.make({
  name: 'user-group-members-field',
  params: {
    field: async () =>
      createFormField({
        name: 'UserGroupMembersField',
        component: UserGroupMembersField,
      }),
  },
});
